// extracted by mini-css-extract-plugin
module.exports = {"row":"Counter_row__qB-H1","value":"Counter_value__2-sRl","button":"Counter_button__3DWPw","textbox":"Counter_textbox__13qA1","asyncButton":"Counter_asyncButton__3Hket"};